// FAQ.jsx
import React, { useEffect, useState } from "react";
import SingleQuestion from "./SingleQuestion";
import { data } from "./data";
import "./styles.css";

export default function FAQ() {
  document.title = "Frequently Asked Questions | AGRA";
  const [questions, setQuestions] = useState(data);
  const [path, setPath] = useState('');
  
  useEffect(() => {
    setPath(window.location.pathname);
  }, []);
  
  return (
    <div className={path !== '/home-frequently-asked-questions' ? 'page-content' : 'max-w-6xl mx-auto p-4 px-4 sm:px-6 lg:px-8'}>
      <h1 className="text-2xl sm:text-3xl font-bold text-center rounded-md bg-gray-100 p-3 sm:p-4 mb-6">
        Empowering You with Insights: APRITS FAQs
      </h1>
      <div className="space-y-4">
        {questions.map((question) => (
          <SingleQuestion
            key={question.id}
            {...question}
          />
        ))}
      </div>
    </div>
  );
}

